import { Field, Text } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import React from "react";
import {
  TYPOGRAPHY_DISPLAY1,
  TYPOGRAPHY_HEADING2,
} from "@/typography-constants";
import classes from "../media-cta.module.css";
import AnimatedCta from "./animated-cta";

export type TextContentProps = {
  headline: Field<string>;
  subheading: Field<string>;
  textColour: Field<string>;
  ctaText: Field<string>;
  mobileView?: boolean;
  isHero: boolean;
};

const TextContent = (props: TextContentProps) => {
  const { headline, subheading, textColour, ctaText, mobileView, isHero } =
    props;

  return (
    <>
      <Text
        tag="h2"
        data-testid="headline"
        field={headline}
        className={clsx(
          TYPOGRAPHY_DISPLAY1,
          isHero ? classes.heroCtaTitle : classes.ctaTitle,
        )}
        style={{
          color: textColour.value || undefined,
        }}
      />
      <Text
        tag="p"
        data-testid="sub-headline"
        field={subheading}
        className={clsx(
          TYPOGRAPHY_HEADING2,
          classes[mobileView ? "ctaSubtitle" : "heroCtaSubtitle"],
        )}
        style={{
          color: textColour.value || undefined,
        }}
      />
      {((mobileView && isHero) || !isHero) && (
        <AnimatedCta
          textColour={textColour}
          ctaText={ctaText}
          isHero={isHero}
          mobileView={mobileView}
        />
      )}
    </>
  );
};

export default TextContent;
